import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
export function useAnnouncements() {
    return useQuery({
        queryKey: ['announcements'],
        queryFn: () => apiClient('/announcements'),
        staleTime: 1000 * 60 * 3,
    });
}
export function useCreateAnnouncement() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (dto) => apiClient('/announcements', { method: 'POST', body: JSON.stringify(dto) }),
        onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['announcements'] }),
    });
}
export function useUpdateAnnouncement(id) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (dto) => apiClient(`/announcements/${id}`, { method: 'PATCH', body: JSON.stringify(dto) }),
        onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['announcements'] }),
    });
}
export function useDeleteAnnouncement() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (id) => apiClient(`/announcements/${id}`, { method: 'DELETE' }),
        onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['announcements'] }),
    });
}
//# sourceMappingURL=useAnnouncements.js.map